// ---
import React from "react";
import {connect} from "react-redux";
import {formValueSelector, reduxForm} from "redux-form";
import {ff, form, utils} from "@mc/mc-legacy";
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import ConfigurationField from "../field/ConfigurationField";
import * as findCombinationsActions from "../../actions/findCombinationsActions";
import ApprovalField from "../field/ApprovalField";
import TypeCombinationField from "../field/TypeCombinationField";
import SignersField from "../field/SignersField";
import * as TypeSignInfo from "../../api/TypeSignInfo";
import classNames from "classnames";
import ApprovalConfigField from "../field/ApprovalConfigField";

const Form = form.Form;
const FormBody = form.FormBody;
const FormActions = form.FormActions;

const validate = (formData) => {
    const errors = {};

    if (!formData.name) {
        errors.name = "Musí být vyplněn název";
    }

    if (!formData.signPracovnikId) {
        errors.signPracovnikId = "Musí být vyplněn podepisující";
    }
    if (formData.description && formData.description.length > 1000) {
        errors.description = "Poznámka může mít maximálně 1000 znaků";
    }

    if (formData.signUntil) {
        const signUntil = new Date(formData.signUntil);
        const today = new Date();
        signUntil.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);
        if (signUntil < today) {
            errors.signUntil = "Termín zpracování nesmí být v minulosti";
        }
    }

    if (formData.files) {
        if (formData.files.length === 0) {
            errors.files = "Musí být vybrán alespoň jeden soubor";
        } else {
            let sign = 0;
            formData.files.forEach(f => {
                if (!f.attachment) {
                    sign++;
                }
            });
            if (sign === 0) {
                errors.files = "Musí být vybrán alespoň jeden soubor k podpisu";
            }
        }
    }

    if (formData.withoutSign && !formData.approvalCode && (!formData.approval || formData.approval.steps.length == 0)) {
        errors.approvalCode = "Musí být nastaven schvalovací proces, pokud je zvolena konfigurace bez podpisu";
    }


    if (formData.withoutSign && ((formData.signers && formData.signers.length != 0) || formData.signConfigurationId)) {
        errors.withoutSign = "Pokud je vybrána podpisová konfigurace nebo nastaveni podepisující, požadavek nemůže být bez podpisu";
    }

    if (!formData.withoutSign && (!formData.signers || formData.signers.length == 0) && !formData.signConfigurationId) {
        errors.signConfigurationId = "Musí být vybrána podpisová konfigurace";
    }

    if (!formData.withoutSign && (formData.signers && formData.signers.length != 0) && !formData.typeCombinationId) {
        errors.typeCombinationId = "Musí být vybrána kombinace k podpisu";
    }

    return errors;
};

const itemTypeList = TypeSignInfo.getValues().map(value => ({id: value, name: TypeSignInfo.getCaption(value)}));

/**
 * Formulář nového požadavku k hromadnému podepsání dokumentů.
 */
class PreNovyPozadavekForm extends React.Component {

    static formName = "preNovyPozadavekForm";

    onChangeWithoutSign() {
        this.props.change("signers", null);
        this.props.change("signConfigurationId", null);
    }

    render() {
        const {
            onClose,
            handleSubmit,
            submitting,
            KombinaceList,
            typeCombinationItems,
            approvalCode,
            signConfigurationId,
            approval,
            signers,
            withoutSign,
            files
        } = this.props;
        const commons = {
            disabled: submitting,
        };
        const items = [];
        KombinaceList.filteredRows &&
        KombinaceList.filteredRows.forEach((item) => {
            items.push({id: item.name, name: item.name});
        });

        const cls = classNames(["w-100", "h-100", "dropzone-label-wrapper"], {
            "drag-active": false,
        });
        return (
            <Form onSubmit={handleSubmit} className={"novy-pozadavek-form"}>
                <FormBody cards>
                    <Row noGutters>
                        <Col xs={6}>
                            <Card>
                                <CardHeader>
                                    <h2>Nahrané soubory</h2>
                                </CardHeader>
                                <CardBody>
                                    <div className={'items-list bordered'}>
                                        {files && files.length > 0 &&
                                            files.map((fileUploaded, index) => {
                                                return (<CardBody className={cls}>
                                                    {fileUploaded.name}
                                                </CardBody>);
                                            })
                                        }
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col xs={6}>
                            <Card>
                                <CardHeader>
                                    <h2>Údaje požadavku</h2>
                                </CardHeader>
                                <CardBody>
                                    <ff.String name={"name"} label={"Název"} required {...commons} />
                                    <Row>
                                        <Col>
                                            <ff.Base
                                                componentClass={ApprovalConfigField}
                                                name={"approvalCode"}
                                                label={"Vybrat schvalování z konfigurace"}
                                                required={withoutSign}
                                                disabled={(approval && approval.steps?.length > 0) || submitting}
                                            />
                                        </Col>
                                        <Col>
                                            <ff.Base
                                                componentClass={ApprovalField}
                                                name={"approval"}
                                                label={"Schvalování"}
                                                disabled={approvalCode || submitting}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <ff.Base
                                                componentClass={ConfigurationField}
                                                name={"signConfigurationId"}
                                                label={"Vybrat podepisující z konfigurace"}
                                                required={!withoutSign}
                                                disabled={(signers && signers.length > 0 && signers[0].pracovnikId !== null) || withoutSign || submitting}
                                            />
                                        </Col>
                                        <Col>
                                            <ff.Base
                                                componentClass={SignersField}
                                                name={"signers"}
                                                label={"Podepisujicí"}
                                                disabled={signConfigurationId || withoutSign|| submitting}
                                            />
                                        </Col>
                                    </Row>
                                    {(signers && signers.length > 0 && signers[0].pracovnikId !== null) &&
                                        <ff.Base
                                            componentClass={TypeCombinationField}
                                            name={"typeCombinationId"}
                                            label={"Kombinace podepsání"}
                                            items={typeCombinationItems}
                                            required
                                            {...commons}
                                        />
                                    }
                                    <div className={'mb-2'}>
                                        <ff.Checkbox
                                            label={false}
                                            checkboxLabel="Bez podpisu"
                                            name={"withoutSign"}
                                            disabled={submitting}
                                            onChange={() => {
                                                this.onChangeWithoutSign();
                                            }}
                                        />
                                    </div>
                                    <ff.String
                                        name={"email"}
                                        label={"Poslat mi při změně upozornění na email"}
                                        {...commons}
                                    />
                                    {<ff.SimpleDate name={"signUntil"} label={"Termín"} {...commons} />}
                                    <ff.Textarea rows={10} name={"description"} label={"Poznámka"} {...commons} />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </FormBody>
                <FormActions onClose={onClose} disabled={submitting} submitButton={"Odeslat"} cancelButton/>
            </Form>
        );
    }
}

function mapStateToProps(state) {
    const selector = formValueSelector(PreNovyPozadavekForm.formName);
    return {
        files: selector(state, "files"),
        KombinaceList: utils.storeFromArea(state, findCombinationsActions.KOMBINACE_LIST),
        approval: selector(state, "approval"),
        withoutSign: selector(state, "withoutSign"),
        approvalCode: selector(state, "approvalCode"),
        signers: selector(state, "signers"),
        typeCombinationId: selector(state, "typeCombinationId"),
        signConfigurationId: selector(state, "signConfigurationId"),
    };
}

const reduxFormObj = reduxForm({
    form: PreNovyPozadavekForm.formName,
    validate: validate,
})(PreNovyPozadavekForm);
export default connect(mapStateToProps)(reduxFormObj);
